/**
 * Delimit number with commas for every three digits.
 * @param  {String} value String of number that is not delimited
 * @return {String}        String of number that is delimited with comma for every three digits
 */
export default function(value) {
  return value.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
